<template>
  <div>
    <h1>Hello Holidays and Office Closures Page!</h1>
  </div>
</template>
